import { Navigate } from "react-router-dom";
import { useAuth } from "./AuthContext";
import PropTypes from "prop-types"; // ✅ Import PropTypes

const ProtectedRoute = ({ children, allowedRoles }) => {
  const { user, loading } = useAuth();

  if (loading) {
    return null; // Or a loading spinner
  }

  if (!user) {
    return <Navigate to="/authentication/sign-in" />;
  }

  if (allowedRoles && allowedRoles.length > 0 && !allowedRoles.includes(user.role_id)) {
    // Redirect to their respective home dashboard if role is not allowed
    return <Navigate to={user.role_id === 3 ? "/user-dashboard" : "/dashboard"} />;
  }

  return children;
};

ProtectedRoute.propTypes = {
  children: PropTypes.node.isRequired,
  allowedRoles: PropTypes.arrayOf(PropTypes.number),
};

export default ProtectedRoute;
